import React from "react";
import { useNavigate, useSearchParams, Navigate } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, KeyRound, CheckCircle2 } from "lucide-react";
import { api } from "../lib/api";

export default function SubcontractorSetPasswordPage() {
  const [params] = useSearchParams();
  const token = params.get("token");
  const [pw, setPw] = React.useState("");
  const [pw2, setPw2] = React.useState("");
  const [busy, setBusy] = React.useState(false);
  const [done, setDone] = React.useState(false);
  const nav = useNavigate();

  if (!token) return <Navigate to="/vognmand/login" replace />;

  const submit = async (e) => {
    e.preventDefault();
    if (pw.length < 8) { toast.error("Adgangskoden skal være mindst 8 tegn"); return; }
    if (pw !== pw2) { toast.error("De to adgangskoder er ikke ens"); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/sc/auth/set-password", { token, new_password: pw });
      localStorage.setItem("ema_sc_token", data.token);
      localStorage.setItem("ema_sc_company", data.subcontractor.company_name || "");
      setDone(true);
      setTimeout(() => nav("/vognmand"), 1200);
    } catch (e) {
      toast.error(e?.response?.data?.detail || "Kunne ikke sætte adgangskode");
    } finally {
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-brand-dark flex items-center justify-center p-5" data-testid="sc-setpw-page">
      <div className="w-full max-w-md">
        <div className="flex items-center gap-3 justify-center mb-8">
          <img src="/brand/ema-logo-transparent.png" alt="" className="h-14" />
          <div className="leading-none">
            <div className="font-display font-bold text-2xl text-white">EMA Kurer<span className="text-brand-red">.</span></div>
            <div className="text-[10px] tracking-[0.25em] uppercase font-semibold text-white/50 mt-1">Vognmand-portal</div>
          </div>
        </div>
        <div className="bg-white p-8">
          {done ? (
            <div className="text-center" data-testid="sc-setpw-done">
              <CheckCircle2 size={48} className="mx-auto text-emerald-600" />
              <h1 className="font-display font-bold text-2xl text-brand-dark mt-3">Adgangskode sat!</h1>
              <p className="text-sm text-brand-text2 mt-2">Du logges ind nu...</p>
            </div>
          ) : (
            <>
              <div className="kicker">Velkommen</div>
              <h1 className="font-display font-bold text-2xl text-brand-dark mt-2">Sæt din adgangskode</h1>
              <p className="text-sm text-brand-text2 mt-2">Mindst 8 tegn. Vælg en stærk adgangskode.</p>
              <form onSubmit={submit} className="space-y-4 mt-6">
                <div>
                  <label className="label-flat">Ny adgangskode</label>
                  <input value={pw} onChange={(e) => setPw(e.target.value)} type="password" required minLength={8} className="input-flat w-full" data-testid="sc-setpw-pw" />
                </div>
                <div>
                  <label className="label-flat">Gentag adgangskode</label>
                  <input value={pw2} onChange={(e) => setPw2(e.target.value)} type="password" required minLength={8} className="input-flat w-full" data-testid="sc-setpw-pw2" />
                </div>
                <button disabled={busy} type="submit" className="btn-primary w-full inline-flex items-center justify-center gap-2" data-testid="sc-setpw-submit">
                  {busy ? <Loader2 className="animate-spin" size={16} /> : <KeyRound size={16} />}
                  Sæt adgangskode & log ind
                </button>
              </form>
            </>
          )}
        </div>
      </div>
    </div>
  );
}
